(function(){
    'use strict';

    angular
    .module('app')
    .controller('CheckboxconfigController', CheckboxconfigController)
 
    CheckboxconfigController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function CheckboxconfigController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.json = "";
        vm.busqueda = false;
        vm.field = "";
        vm.update = function(){
			/*var j = {
				"references":{
					"modificable":vm.modificable
				}
			};*/
            var j = JSON.parse($('#fieldconfig-value').val());
            j.references["modificable"] = vm.modificable;
            
			vm.scopeParent.$parent.fieldsVm.jsonValue = angular.toJson(j);
			$('#fieldconfig-value').val(vm.scopeParent.$parent.fieldsVm.jsonValue);
        }
        vm.init = function(scopeParent){
        	vm.scopeParent = scopeParent;
        	//console.log(scopeParent);
        	var valorJson = $('#fieldconfig-value').val();
        	if(valorJson!=""){
        		vm.json = JSON.parse(valorJson);
                if(typeof vm.json.references.modificable!='undefined'){
                    vm.modificable = vm.json.references.modificable;
                }
        	}
        	vm.update();
        }
    } 

})();